import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import { serverIp, toCurrency, firebaseAuth, pythonApiIp, logComponentLoad } from '../../../../config/constants.js'
import axios from 'axios'
import { Table, Form, Divider, Segment, Button } from 'semantic-ui-react';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import { SingleDatePicker } from 'react-dates';
import SendSinglePayroll from './SendSinglePayroll';

class Payroll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payList: [],
            approved: false,
            recentPay: [],
            algoliaUser: ''
        }
    }


    componentDidMount() {
        console.log("ddx13 ++++++ componentDidMount ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;



                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)


                }
            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");

        logComponentLoad(returnObject, "Payroll");

        if (returnObject.algoliaUser && returnObject.algoliaUser.perms.includes("payroll")) {
            this.getPayRollList();
            this.getRecentPayRoll();
            this.setState({
                algoliaUser: returnObject.algoliaUser,
                approved: true
            })
        } else {
            console.log("user not approved")
        }

    }

    getPayRollList = () => {
        this.setState({ loading: true });

        axios.post(pythonApiIp + 'getPayrollList', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.result) {

                    if (response.data.shirtTypes) {
                        console.log("entx22 result:" + JSON.stringify(response.data.payList, null, 3));
                        this.setState({ loading: false, payList: response.data.shirtTypes });
                    } else {

                        this.setState({ loading: false });

                        alert("payList is empty");
                    }


                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    getRecentPayRoll = () => {
        this.setState({ loading: true });

        axios.post(pythonApiIp + 'getRecentPayRoll', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.result) {

                    if (response.data.recentPay) {
                        console.log("entx22 result:" + JSON.stringify(response.data.recentPay, null, 3));
                        this.setState({ loading: false, recentPay: response.data.recentPay });
                    } else {

                        this.setState({ loading: false });

                        this.getRecentPayRoll();

                        alert("recentPay is empty");
                    }


                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
    }

    markPayRoll = () => {
        console.log("++++++: markPayRoll :++++++")
        this.setState({ loading: true });

        axios.post(pythonApiIp + 'payMonthlyPayroll', {
            apiKey: "ad#4fsdUUddf",
            enteredBy: this.state.user.email,
            payDate: this.state.dateNum
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.result) {

                    console.log("entx22 result:" + JSON.stringify(response.data, null, 3));
                    this.setState({ loading: false });

                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    render() {


        const payListTable = this.state.payList.map((pay, index) =>

            <Table.Row key={pay.idshirtypes}>
                <Table.Cell>{index + 1}</Table.Cell>
                <Table.Cell>{pay.shirttype}</Table.Cell>
                <Table.Cell>{toCurrency(pay.shirttypebuycost)}</Table.Cell>
                <Table.Cell>
                    <SendSinglePayroll 
                        shirttypebuycost={pay.shirttypebuycost} 
                        shirttype={pay.shirttype} 
                        dateNum={this.state.dateNum} 
                        dateString={this.state.dateString}
                        user={this.state.user}
                        />
                </Table.Cell>
            </Table.Row>

        )

        const payTable = this.state.payList.length > 0
            ? <div>
                <Divider horizontal>{'LIST'}</Divider>
                <Table celled padded>
                    <Table.Header >
                        <Table.Row>
                            <Table.HeaderCell>#</Table.HeaderCell>
                            <Table.HeaderCell>Shirt Type</Table.HeaderCell>
                            <Table.HeaderCell>shirttypebuycost</Table.HeaderCell>
                            <Table.Cell>Cost</Table.Cell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {payListTable}
                    </Table.Body>
                </Table>
            </div>
            : ''

        const recentPayRows = this.state.recentPay.map((pay, index) =>

            <Table.Row key={pay.iditemsboughtdetail}>
                <Table.Cell>{index + 1}</Table.Cell>
                <Table.Cell>{pay.dadate}</Table.Cell>
                <Table.Cell>{pay.item}</Table.Cell>
                <Table.Cell>{toCurrency(pay.price)}</Table.Cell>

            </Table.Row>

        )

        // const recentPayTable = this.state.recentPay.length > 0
        //     ? <div>
        //         <Divider horizontal>{'RECENT PAY'}</Divider>
        //         <Table celled padded>
        //             <Table.Header>
        //                 <Table.Row>
        //                     <Table.HeaderCell>#</Table.HeaderCell>
        //                     <Table.HeaderCell>Date</Table.HeaderCell>
        //                     <Table.HeaderCell>Item</Table.HeaderCell>
        //                     <Table.HeaderCell>Amount</Table.HeaderCell>
        //                 </Table.Row>
        //             </Table.Header>

        //             <Table.Body>
        //                 {recentPayRows}
        //             </Table.Body>
        //         </Table>
        //     </div>
        //     : ''



        const payButton = this.state.dateString
            ? <Button>Pay</Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("payroll")
            ? <div>
                <Form size='large' onSubmit={this.markPayRoll}>
                    <Segment stacked>
                        <h3>ENTER PAY DATE</h3>

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {payButton}
                    </Segment>

                </Form>
                {/* {recentPayTable} */}
                {payTable}

                <br />
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}




            </div>);
    }
}

export default Payroll;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Payroll_Expenses/Payroll.js